import React from 'react';
import PopupEditRow from '../PopupEditRow/PopupEditRow';

export function ViewColumnFormatter(cellContent) {
  return (
    <PopupEditRow
      viewMode={true}
      canCreate={cellContent.canCreate}
      status={cellContent.status}
      invoiceOrderID={cellContent._id}
    />
  );
}
